import { IParty } from './models/models'

export const exportHandler = async (apiUrl: string, fileName: string, fileType: string = 'xlsx', replacedUrl?: boolean, returnLink: boolean = false) => {
	const API_URL = process.env.REACT_APP_API_URL
	const REPLACED_API_URL = API_URL?.replace('remote-control-panel/', '')
	const token = localStorage.getItem('accessToken')

	const response = await fetch(`${replacedUrl ? REPLACED_API_URL : API_URL}${apiUrl}`, {
		headers: {
			Accept: 'application/octet-stream',
			authorization: `Bearer ${token}`,
		},
	})

	if (response.status === 403) {
		const errObj = await response.json()
		throw new Error(errObj?.message)
	}

	const file = await response.blob()
	const blob = new Blob([file], { type: 'application/octet-stream' })
	const url = window.URL.createObjectURL(blob)

	if (returnLink) return url

	const a = document.createElement('a')
	a.style.display = 'none'
	document.body.appendChild(a)
	a.href = url
	a.download = `${fileName}.${fileType}`
	a.click()
	window.URL.revokeObjectURL(url)
	a.remove()
}

export const getFile = async (path: string) => {
	const API_URL = process.env.REACT_APP_API_URL
	const token = localStorage.getItem('accessToken')

	const response = await fetch(`${API_URL}files/show`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({ path }),
	})
	const file = await response.blob()
	const blob = new Blob([file], { type: 'application/octet-stream' })
	const url = window.URL.createObjectURL(blob)

	return url
}

export const generateFormData = (data: any): FormData => {
	const formData = new FormData()

	for (const [key, value] of Object.entries<any>(data)) {
		if (!!value) {
			if (value instanceof FileList && value.length) {
				Array.from(value).forEach((i) => {
					formData.append(key, i)
				})
			} else {
				formData.append(key, Object.prototype.toString.call(value) === '[object Object]' ? JSON.stringify(value) : value)
			}
		}
	}

	return formData
}

export const getPartyFilesLinks = (party: IParty): string[] => {
	const links = Object.values(party.files).flat() as string[]

	if (!party.files?.ttn || !party.files?.ttn?.length) {
		links.push(`refuellings/${party.refuellingId}/documents/ttn?pdfMode=3`)
	}
	if (!party.files?.exciseInvoices || !party.files?.exciseInvoices?.length) {
		links.push(`refuellings/${party.refuellingId}/documents/excise-invoice?pdfMode=3`)
	}

	return links.filter((i) => !!i)
}

export const formatPhone = (phone?: string | number) => {
	if (!phone) return phone
	return String(phone).indexOf('+') === -1 ? `+${phone}` : phone
}
